import styled from 'styled-components';
import { Box, MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  gap: '10px'
});

export const Wrapper = styled(Box)({

});
